import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  ModalResponsive,
  Loading,
  LoadingCircle,
  Pagination,
  UsersCard,
  Tooltip,
} from '../../../components';
import Edit from '../../../assets/buttons/edit.svg';
import Analisys from '../../../assets/buttons/analisys.svg';
import Deactivate from '../../../assets/buttons/deactivate.svg';
import Reactivate from '../../../assets/buttons/reactivate.svg';
import {
  searchArrayOfObjects,
  sendNotification,
  formatDocumentCNPJ,
} from '../../../utils/functions';
import makeAnimated from 'react-select/animated';
import { usePermissions } from '../../../hooks/usePermissions';
import { WithContext as ReactTags } from 'react-tag-input';

import { FaRegCircleQuestion } from 'react-icons/fa6';
import { Container, Content } from '../../../styles/lib/grid';
import { TabsContainer } from '../../../styles/lib/tabs';
import { Select, Option } from '../../../styles/lib/dynamic-filter';
import { IProfileGroup } from '../../../interfaces/permissions';
import { AxiosResponse } from 'axios';
import { usePagination } from '../../../hooks/usePagination';
import * as S from '../../AccessControl/Users/UsersStyles';
import ValidationUserDialog from './Components/ValidationUser/ValidationDialog';
import useDealer from '../../../hooks/useDealer/useDealer';
import { useClient } from '../../../hooks/useClient';

interface DealersProps {
  setTotalEmAnalise: Dispatch<SetStateAction<string | null>>;
}

const toastConfig = {
  autoClose: 3000,
  hideProgressBar: true,
  type: 'success',
};

export const NewDealers: React.FC<DealersProps> = ({ setTotalEmAnalise }) => {
  const {
    returnAllDealers,
    changeUserStatus,
    editUserInfo,
    analyzeUser,
    isLoading,
    isLoadingAPICall,
    dealers,
    metadata,
  } = useDealer();

  const [
    { profileGroups, responsibleChannel },
    ,
    ,
    ,
    ,
    ,
    fetchResponsibleChannel,
  ] = usePermissions();

  const [apiError, setApiError] = useState<string | null>(null);

  const [area, setArea] = useState<any>([]);
  const [profile, setProfile] = useState('');
  const [cnpjsRaiz, setCnpjsRaiz] = useState<any>([]);
  const [{ reject }, consultingCnpj] = useClient();

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openAnalysisModal, setOpenAnalysisModal] = useState(false);
  const [openAnalysisModalRevendedor, setOpenAnalysisModalRevendedor] =
    useState(false);
  const [openReactivateModal, setOpenReactivateModal] = useState(false);
  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);

  const [filters, setFilters] = useState<{
    type: string;
    term: string;
    tipoPerfil: string;
  }>({
    type: '',
    term: '',
    tipoPerfil: '',
  });

  const [editDealer, setEditDealder] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [isApprove, setIsApprove] = useState(true);
  const [reproveReason, setReproveReason] = useState('');

  useEffect(() => {
    fetchResponsibleChannel();
    handleAllUsers();
    setApiError(null);
  }, []);

  const animatedSelectComponents = makeAnimated();

  useEffect(() => {
    if (!openEditModal) {
      setCnpjsRaiz([]);
    } else {
      patchCnpjsRaiz(user);
    }
  }, [openEditModal]);

  const profileTypes = useMemo(() => {
    return profileGroups.map((e: any) => {
      return e;
    });
  }, [profileGroups]);

  useEffect(() => {
    setTotalEmAnalise(metadata.totalEmAnalise);
  }, [setTotalEmAnalise, metadata]);

  const handleAreaChoosen = (area: any, user: any) => {
    setUser({ ...user, areasAtuacao: area });
    setArea(area);
  };

  const { currentPage, pageSize, handlePageChange, resetPagination } =
    usePagination({
      totalItems: dealers.pagination?.totalItems || 0,
      onPageChange: (currentPage, pageSize) => {
        returnAllDealers({
          ...filters,
          currentPage,
          pageSize,
          isNew: true,
        });
      },
    });

  const handleAllUsers = () => {
    resetPagination();
    returnAllDealers({
      ...filters,
      pageSize,
      currentPage: 1,
      isNew: true,
    });
  };

  const searchUsers = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleAllUsers();
  };

  const handleUserAction = async (
    actionFn: () => Promise<AxiosResponse | undefined>,
    successMessage: string,
    errorMessage?: string,
  ) => {
    try {
      await actionFn();
      sendNotification(successMessage, toastConfig);
      setOpenAnalysisModal(false);
      setOpenEditModal(false);
      setReproveReason('');
      setApiError(null);
    } catch (e: any) {
      const errorToDisplay =
        errorMessage || e.response?.data?.errors || e.message;
      setApiError(errorToDisplay);
    }
  };

  const patchCnpjsRaiz = (user: any) => {
    if (!user || !user.cnpj) {
      return;
    }

    const existingCnpjs = new Set(
      cnpjsRaiz.map((cnpj: { id: string; text: string }) => cnpj.id),
    );

    const uniqueFormattedCnpjs = user.cnpj
      .filter((cnpj: any) => !existingCnpjs.has(cnpj))
      .map((cnpj: any) => ({
        id: cnpj,
        text: formatCnpj(cnpj),
      }));

    setCnpjsRaiz((prevCnpjsRaiz: any) => {
      const updatedCnpjs = [...prevCnpjsRaiz, ...uniqueFormattedCnpjs];
      const uniqueCnpjs = Array.from(new Set(updatedCnpjs.map(c => c.id))).map(
        id => updatedCnpjs.find(c => c.id === id),
      );

      return uniqueCnpjs;
    });
  };

  const formatCnpj = (cnpj: string) => {
    if (typeof cnpj !== 'string') {
      return cnpj;
    }
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(
      5,
      8,
    )}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`;
  };

  const updateUser = async () => {
    const response: any = await editUserInfo({
      ...user,
      areasAtuacao: area,
      cnpjsRaiz: cnpjsRaiz.map((i: { id: string; text: string }) =>
        i.id.replace(/[./-]/g, '').toUpperCase(),
      ),
    });
    if (response?.status >= 200 && response?.status < 300) {
      setOpenEditModal(false);
      sendNotification(
        `As alterações no usuário ${
          user?.nome ?? user?.nomeContato ?? user?.razaoSocial
        } foram realizadas com sucesso.`,
        toastConfig,
      );

      handleAllUsers();
    }
  };
  const approveUser = () => {
    handleUserAction(
      () => analyzeUser(user?.id, isApprove, reproveReason, true),
      `O usuário ${
        user?.nome ?? user?.nomeContato ?? user?.razaoSocial
      } foi aprovado.`,
    );
  };

  const repproveUser = async () => {
    handleUserAction(
      () => analyzeUser(user?.id, isApprove, reproveReason, true),
      `O usuário ${
        user?.nome ?? user?.nomeContato ?? user?.razaoSocial
      } foi reprovado.`,
    );
  };

  const activateUser = async () => {
    await changeUserStatus(user?.id, true);
    sendNotification(`O usuário ${user?.razao} foi reativado.`, toastConfig);
    setOpenReactivateModal(false);

    handleAllUsers();
  };

  const deactivateUser = async () => {
    await changeUserStatus(user?.id, false);
    sendNotification(`O usuário ${user?.razao} foi desativado.`, toastConfig);
    setOpenDeactivateModal(false);
    handleAllUsers();
  };

  const renderGrupoEconomico = (grupoEconomico: any) => {
    if (
      !grupoEconomico ||
      !Array?.isArray(grupoEconomico) ||
      grupoEconomico?.length === 0
    ) {
      return '-';
    }

    const primary =
      typeof grupoEconomico?.[0] === 'string'
        ? grupoEconomico?.[0]
        : 'Principal';
    const others = Array.isArray(grupoEconomico)
      ? grupoEconomico?.slice(1)
      : [];

    return (
      <S.ListInline>
        <ul className="no-flex">
          <li>
            <span>Principal</span> {primary}
          </li>
          {others.length > 0 && (
            <li className="same">
              <span>Outros</span> {others.join(', ')}
            </li>
          )}
        </ul>
      </S.ListInline>
    );
  };

  const treatmentUserAttributes = (user: any) => {
    setUser(user);
    setProfile(user.perfil?.nome);
    setArea(null);
    if (user?.canaisResponsaveis?.length > 0) {
      const canaisResponsaveis: any = user?.canaisResponsaveis.map((r: any) => {
        const matchingGroup: any = responsibleChannel.find(
          (area: any) => area.label === r,
        );
        const value = matchingGroup ? matchingGroup.value : null;
        return {
          value,
          label: r,
        };
      });
      setArea(canaisResponsaveis);
    } else {
      setArea([]);
    }
  };

  const handleAdditionCnpjs = async (tag: { id: string; text?: string }) => {
    const cnpjText = (tag.text ?? tag.id).replace(/[./-]/g, '').toUpperCase();

    const formattedCnpj = formatDocumentCNPJ(cnpjText);

    const newCnpj = {
      id: tag.id,
      text: formattedCnpj,
    };

    const responseConsulted = await consultingCnpj(cnpjText);
    const grupoEconomico = responseConsulted?.cliente?.grupoEconomico || '';

    if (grupoEconomico && !user?.grupoEconomico.includes(grupoEconomico)) {
      setCnpjsRaiz([...cnpjsRaiz, newCnpj]);
      setUser({
        ...user,
        cnpj: [...user.cnpj, tag.id],
        grupoEconomico: [...user.grupoEconomico, grupoEconomico],
      });
    }
  };

  const handleDeleteCnpjs = (index: number) => {
    if (!Array.isArray(user?.cnpj)) return;
    const newCnpjs = cnpjsRaiz.filter((_: string, i: number) => i !== index);
    setCnpjsRaiz(newCnpjs);

    const newUserCnpjs = user.cnpj.filter(
      (_: string, i: number) => i !== index,
    );

    const newGrupoEconomico = user.grupoEconomico.filter(
      (_: string, i: number) => i !== index,
    );

    setUser({
      ...user,
      cnpj: newUserCnpjs,
      grupoEconomico: newGrupoEconomico,
    });
  };

  const handleCnpjsDrag = (tag: any, currPos: number, newPos: number) => {
    const newCnpjs = [...cnpjsRaiz];
    const [movedCnpj] = newCnpjs.splice(currPos, 1);
    newCnpjs.splice(newPos, 0, movedCnpj);
    setCnpjsRaiz(newCnpjs);

    const newUserCnpjs = [...user.cnpj];
    const [movedUserCnpj] = newUserCnpjs.splice(currPos, 1);
    newUserCnpjs.splice(newPos, 0, movedUserCnpj);

    const newGrupoEconomico = [...user.grupoEconomico];
    const [movedGrupoEconomico] = newGrupoEconomico.splice(currPos, 1);
    newGrupoEconomico.splice(newPos, 0, movedGrupoEconomico);

    setUser({
      ...user,
      cnpj: newUserCnpjs,
      grupoEconomico: newGrupoEconomico,
    });
  };

  const isRevendedor = (perfil: string) => {
    return perfil === 'revendedor-allied';
  };

  const renderRepresentantes = (representantes: any) => {
    const novosUsuarios = representantes?.filter(
      (representante: any) => !representante?.analisado,
    );
    const cadastrados = representantes?.filter(
      (representante: any) => representante?.analisado,
    );

    return (
      <>
        <h2>Novos Usuários</h2>
        <hr style={{ margin: '10px 0 20px 0' }} />
        {novosUsuarios?.map((elm: any) => (
          <UsersCard
            key={elm?.id}
            user={elm}
            isAccordion={!isRevendedor(elm?.perfil?.nome)}
            action={() => {
              setEditDealder(false);
              setIsApprove(true);
              setApiError(null);
              treatmentUserAttributes(elm);
              setOpenAnalysisModalRevendedor(true);
            }}
          >
            {!isRevendedor(elm?.perfil?.nome) && (
              <S.CardButtons>
                <S.IconButton
                  className={!elm.analisado ? 'edit disabled' : 'edit'}
                  onClick={() => {
                    setOpenEditModal(true);
                    setApiError(null);
                    treatmentUserAttributes(elm);
                    patchCnpjsRaiz(elm);
                  }}
                  disabled={!elm.analisado}
                >
                  <img src={Edit} width={16} />
                  Editar
                </S.IconButton>
                {!elm.analisado && (
                  <S.IconButton
                    className="analisys"
                    onClick={() => {
                      setOpenAnalysisModal(true);
                      setIsApprove(true);
                      setApiError(null);
                      treatmentUserAttributes(elm);
                    }}
                  >
                    <img src={Analisys} width={16} />
                    Analisar
                  </S.IconButton>
                )}
                {elm.ativo && elm.analisado && (
                  <S.IconButton
                    className="deactivate"
                    onClick={() => {
                      setOpenDeactivateModal(true);
                      setUser(elm);
                    }}
                  >
                    <img src={Deactivate} width={16} />
                    Desativar
                  </S.IconButton>
                )}
                {!elm.ativo && elm.analisado && (
                  <S.IconButton
                    className="reactivate"
                    onClick={() => {
                      setOpenReactivateModal(true);
                      setUser(elm);
                    }}
                  >
                    <img src={Reactivate} width={16} />
                    Reativar
                  </S.IconButton>
                )}
              </S.CardButtons>
            )}
          </UsersCard>
        ))}
      </>
    );
  };

  return (
    <Container>
      <Content>
        <S.SearchWrapper>
          <S.SearchCell>
            <S.Search onSubmit={searchUsers}>
              <S.InputContainer>
                <S.Select
                  value={filters.type}
                  className="floating"
                  onChange={(e: any) => {
                    setFilters(prev => ({
                      ...prev,
                      type: e.target.value,
                      term: '',
                    }));
                  }}
                >
                  <S.Option value="">Selecione</S.Option>
                  <S.Option value="cnpj">CNPJ</S.Option>
                  <S.Option value="razao">Nome / Razão Social</S.Option>
                  <S.Option value="email">E-mail</S.Option>
                </S.Select>
                <S.Input
                  maxLength={35}
                  value={filters.term}
                  onChange={(e: any) =>
                    setFilters(prev => ({
                      ...prev,
                      term:
                        prev.type === 'cnpj'
                          ? formatDocumentCNPJ(e.target.value)
                          : e.target.value,
                    }))
                  }
                  placeholder={'Faça sua busca...'}
                />
              </S.InputContainer>

              <S.ButtonsContainer>
                <S.Button type="submit">Buscar</S.Button>
              </S.ButtonsContainer>
            </S.Search>
          </S.SearchCell>

          <S.CardInfo>
            <S.CardCell className="left">
              <S.CardText className="active">Ativos</S.CardText>
              <p>
                <S.CardText className="bolder">
                  {metadata.totalAtivos ?? '-'}/
                </S.CardText>
                <S.CardText className="smallest">
                  {metadata.total ?? '-'}
                </S.CardText>{' '}
                <S.CardText className="info">revendedores</S.CardText>
              </p>
            </S.CardCell>
            <S.CardCell>
              <S.CardText className="inactive">Inativos</S.CardText>
              <p>
                <S.CardText className="bolder">
                  {metadata.totalInativos ?? '-'}/
                </S.CardText>
                <S.CardText className="smallest">
                  {metadata.total ?? '-'}
                </S.CardText>{' '}
                <S.CardText className="info">revendedores</S.CardText>
              </p>
            </S.CardCell>
          </S.CardInfo>
        </S.SearchWrapper>

        <TabsContainer>
          {isLoading ? (
            <Loading />
          ) : (
            renderRepresentantes(dealers.representantes)
          )}
        </TabsContainer>

        {!isLoading && dealers.representantes?.length === 0 && (
          <S.Message>Nenhum resultado encontrado.</S.Message>
        )}

        {!isLoading && dealers.representantes?.length !== 0 && (
          <Pagination
            currentPage={currentPage}
            paginationSize={pageSize}
            onPageChange={handlePageChange}
            totalItems={dealers.pagination?.totalItems}
          />
        )}
      </Content>

      <>
        <ValidationUserDialog
          isOpen={openAnalysisModalRevendedor}
          user={user}
          onClose={() => {
            setOpenAnalysisModalRevendedor(false);
            handleAllUsers();
          }}
          allowEdit={editDealer}
        />
      </>

      <ToastContainer
        closeButton={false}
        transition={Slide}
        position="bottom-center"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Container>
  );
};
